import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {
    ADDRESS_PANEL_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS, PAYMENT_DETAILS_PANEL_URL, PAYMENT_FAILED_PANEL_URL
} from "../PanelConstants.js";
import {LoadingSpinner, wrapInSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {
    apiCancelDonation, apiEditDonationWithCds,
    apiUpdateDonationAmount,
    apiUpdateDonationPaymentMethod, DonationStore
} from "../../../client/state/DonationStore.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {apiDonate, apiDonateWithCds} from "../../../client/state/DonationStore.js";
import {iFrameState} from "../../services/IFrameState.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient.js";
import {Messages} from "../../Messages.js";
import {Money} from "../../../client/state/misc/Money.js";
import {FLOW_CHECKPOINT, FLOW_TYPE, PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {Device} from "../../../stem-core/src/base/Device.js";
import {CARD_SECTION_STATE, PaymentMethodController} from "./PaymentMethodController.js";
import {ADDRESS_SECTION_STATE} from "../pages/panels/address/AddressPanel.jsx";
import {UserAddressStore} from "../../../client/state/UserAddressStore.js";
import {BaseFlowHandler, sendFlowCheckpoint} from "./BaseFlowHandler.js";
import {Controller} from "./Controller.js";
import {AddressController} from "./AddressController.js";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";
import {collapseIframeAndExpandWallet} from "../../widget/misc/WidgetUtils.js";
import {authService} from "../../../client/connection/services/AuthService.js";


export class DonationFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.donation;

    payload = null;

    frequency = null;
    isCustomAmount = false;
    donationAmount = "";
    latestDonationFee = null;
    payDonationFeeCheckboxChecked = false;

    previouslyCanceledDonation = null;

    async start() {
        const {editRecurring, skipCTA} = iFrameState;

        const offer = iFrameMerchantService.getDonationOffer();
        if (offer && !iFrameUserDataService.getActiveRecurringDonation()) {
            if (!offer.hasAmountChoice()) {
                this.donationAmount = offer.predefinedAmounts[0];
            }
            if (!offer.hasFrequencyChoice()) {
                this.frequency = offer.getFrequencyOptions()[0];
            }
        }

        if (editRecurring && iFrameUserDataService.getActiveRecurringDonation()) {
            this.initEditDonation();
        } else {
            this.initDonate();
        }

        if (editRecurring) {
            Router.changeURL(INLINE_EDIT_DONATION_URLS.donate);
        } else if (skipCTA) {
            if (authService.isAuthenticated()) {
                // This is a "convention" of options that leads to a one-time donation
                // flow (for example, from the wallet's 'Make another donation' button).
                // TODO: Make this more explicit, what this does is very well hidden.
                Router.changeURL(INLINE_DONATION_URLS.donate);
                return;
            }
            await iFrameAuthService.promptAuthenticationIfNeeded();
            if (iFrameUserDataService.getActiveRecurringDonation()) {
                collapseIframeAndExpandWallet();
            } else {
                Router.changeURL(INLINE_DONATION_URLS.donate);
            }
        } else {
            Router.changeToCustomPanel();
        }
    }

    initDonate() {
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            getChooseCardButtonLabel: () => Device.isMobileDevice() ? Messages.finalizePayment : Messages.selectCard,
            getPayWithAddedCardButtonLabel: () => Device.isMobileDevice() ? Messages.finalizePayment : Messages.continue,
            getScope: () => PaymentMethodStore.Scope.PRIVATE,
            onSelectSuccess: async () => {
                if (!Device.isMobileDevice()) { // TODO: This is not that legit.
                    Router.changeURL(INLINE_DONATION_URLS.donate);
                    return;
                }
                await this.donateInlineFlowDonate();
            },
        });
    }

    initEditDonation() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        this.payDonationFeeCheckboxChecked = donation.isDonationFeePaid();
        this.frequency = donation.frequency;
        this.donationAmount = donation.computeAmount();
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            entry: donation,
            savePaymentMethod: true,
            initialPaymentMethod: donation.getPaymentMethod(),
            selectedPaymentMethod: donation.getPaymentMethod(),
            getChooseCardButtonLabel: () => Messages.updatePaymentMethod,
            getPayWithAddedCardButtonLabel: () => Messages.updatePaymentMethod,
            getScope: () => PaymentMethodStore.Scope.PRIVATE,
            onSelectSuccess: () => Router.changeURL(INLINE_EDIT_DONATION_URLS.donate),
        });
    }

    getFrequency() {
        return this.frequency || iFrameMerchantService.getDonationOffer().defaultFrequency;
    }

    getDonationAmount() {
        const {predefinedAmounts, defaultPredefinedAmountIndex} = iFrameMerchantService.getDonationOffer();
        return this.donationAmount || predefinedAmounts[defaultPredefinedAmountIndex];
    }

    getDonationFee() {
        if (this.donationAmount) {
            this.latestDonationFee = DonationStore.computeFeeFromAmount(this.donationAmount, iFrameMerchantService.merchantId);
        }
        return this.latestDonationFee;
    }

    getTotalAmount() {
        return this.donationAmount + (this.payDonationFeeCheckboxChecked ? this.getDonationFee() : 0);
    }

    setPayload(payload) {
        this.payload = payload;
    }

    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    isValid() {
        return !!this.donationAmount;
    }

    formatAmount(amount) {
        return new Money(amount, iFrameMerchantService.getDonationOffer().getCurrency()).toString();
    }

    // TODO: These are only here temporarily.

    getDonateComponentButtonLabel() {
        if (!this.donationAmount || !this.getFrequency()) {
            return Messages.donate;
        }
        const formattedAmount = this.formatAmount(this.getTotalAmount());
        const formattedFrequency = this.getFrequency().isOneTime() ? "" : "/" + this.getFrequency().name.toLowerCase();
        return Messages.donateInlineFlowButton(formattedAmount, formattedFrequency);
    }

    shouldRenderDonatePage() {
        return Device.isMobileDevice() && (!this.donationAmount || !this.frequency || iFrameState.allowUserToCoverFees);
    }

    getEditDonationComponentButtonLabel() {
        return !this.donationAmount ? Messages.update : Messages.editDonationInlineFlowButton(
            this.formatAmount(this.getTotalAmount()),
            this.getFrequency().name.toLowerCase()
        );
    }

    // TODO: Rename all of these methods. This shouldn't be called like this?
    async donate() {
        const donate = () => LoadingSpinner.call(async () => {
            const apiDonateFunction = iFrameMerchantService.isCDSPaymentMethod() ? apiDonateWithCds : apiDonate;
            const donation = await apiDonateFunction({
                ...this.payload,
                recurringOfferId: iFrameMerchantService.getDonationOffer().id,
                ...(await Controller.paymentMethod.extractPaymentMethodFields()),
            });
            if (donation.isActive() || donation.isFinished()) {
                sendFlowCheckpoint(FLOW_TYPE.donation, FLOW_CHECKPOINT.complete, {
                    donationId: donation.id,
                    offerId: donation.recurringOfferId,
                    // TODO @Mihai: Change this
                    amount: donation.getPrice().toMainUnitString({includeSymbol: false}),
                    currency: donation.currency.isoCode,
                    recurring: donation.isRecurring(),
                    frequency: donation.frequency.toString()
                });
            }
        });

        if (iFrameMerchantService.getDonationOffer().shouldCollectAddress() && !this.payload.userAddressId) {
            // TODO @branch this should be an await
            Controller.address = new AddressController({
                addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
                onSelectSuccess: async () => {
                    this.payload.userAddressId = Controller.address.selectedAddress.id;
                    await donate();
                },
                onSelectCancel: () => {
                    delete this.payload.userAddressId;
                    Router.back();
                },
                continueLabel: Messages.finalizeDonation,
            });
            Router.changeURL(ADDRESS_PANEL_URL);
        } else {
            await donate();
        }
    }

    async donateInlineFlowDonate() {
        const commonPayload = {
            amount: this.getTotalAmount(),
            frequency: this.getFrequency(),
            coversFees: this.payDonationFeeCheckboxChecked,
        };
        const payload = {
            ...commonPayload,
            ...(await Controller.paymentMethod.extractPaymentMethodFields()),
        };
        this.setPayload(payload);

        dispatchAnalyticsEvent(AnalyticsEventType.ATTEMPT_DONATE, {
            ...commonPayload,
            isCustomAmount: this.isCustomAmount,
        });

        try {
            await this.donate();
            Router.changeURL(INLINE_DONATION_URLS.thankYou);
        } catch (error) {
            Controller.paymentMethod.update({
                paymentError: error,
                retryPayment: () => this.donateInlineFlowDonate(),
            });
            Router.changeURL(PAYMENT_FAILED_PANEL_URL);
        }
    }

    @wrapInSpinner
    async cancel() {
        const donation = this.getDonation();

        await apiCancelDonation(donation.id);
        this.previouslyCanceledDonation = donation;
        Router.changeURL(INLINE_EDIT_DONATION_URLS.cancelSuccess);
    }

    @wrapInSpinner
    async updateDonation(donationAmount) {
        const donation = this.getDonation();

        if (iFrameMerchantService.isCDSPaymentMethod()) {
            if (this.payload?.paymentInfo) {
                const activeDonation = iFrameUserDataService.getActiveRecurringDonation();
                await apiEditDonationWithCds({
                    amount: donationAmount,
                    frequency: activeDonation.frequency,
                    userAddressId: activeDonation.getShippingAddress()?.id || UserAddressStore.all()[0]?.id,
                    recurringOfferId: activeDonation.recurringOfferId,
                    paymentInfo: this.payload.paymentInfo,
                });
                Router.changeURL(INLINE_EDIT_DONATION_URLS.thankYou);
            } else {
                Controller.paymentMethod.update({
                    getPayWithAddedCardButtonLabel: () => Messages.continue,
                    getScope: () => PaymentMethodStore.Scope.PRIVATE,
                    onSelectSuccess: async () => {
                        this.setPayload({
                            coversFees: this.payDonationFeeCheckboxChecked,
                            ...(await Controller.paymentMethod.extractPaymentMethodFields())
                        });
                        await this.updateDonation(donationAmount);
                    }
                });
                Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
            }
        } else {
            await apiUpdateDonationAmount(donation.id, donationAmount, this.payDonationFeeCheckboxChecked);
            await apiUpdateDonationPaymentMethod(donation.id, Controller.paymentMethod.selectedPaymentMethod?.id);
            Router.changeURL(INLINE_EDIT_DONATION_URLS.thankYou);
        }
    }
}
